import React, { ForwardedRef, forwardRef } from 'react';
import { Icon } from 'react-feather';
import PropTypes from 'prop-types';

const FileCheck: Icon = forwardRef(
  (
    { color = 'currentColor', size = 16, ...rest },
    ref: ForwardedRef<SVGSVGElement>
  ) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        ref={ref}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        {...rest}
      >
        <g clipPath="url(#clip0_2731_135766)">
          <path
            d="M13.3 3.69069L10.976 1.36668C10.5437 0.93207 10.0295 0.587499 9.46319 0.352912C8.89686 0.118325 8.28964 -0.00162037 7.67665 1.65308e-05H4.66665C3.78292 0.0010751 2.93569 0.352605 2.31079 0.977497C1.6859 1.60239 1.33437 2.44962 1.33331 3.33335V12.6667C1.33437 13.5504 1.6859 14.3977 2.31079 15.0225C2.93569 15.6474 3.78292 15.999 4.66665 16H11.3333C12.217 15.999 13.0643 15.6474 13.6892 15.0225C14.3141 14.3977 14.6656 13.5504 14.6667 12.6667V6.99002C14.6683 6.37703 14.5483 5.7698 14.3138 5.20348C14.0792 4.63715 13.7346 4.12297 13.3 3.69069ZM12.3573 4.63335C12.5607 4.84296 12.7357 5.07829 12.878 5.33335H9.99998C9.82317 5.33335 9.6536 5.26312 9.52858 5.13809C9.40355 5.01307 9.33331 4.8435 9.33331 4.66669V1.78868C9.58838 1.93094 9.82371 2.10598 10.0333 2.30935L12.3573 4.63335ZM13.3333 12.6667C13.3333 13.1971 13.1226 13.7058 12.7475 14.0809C12.3725 14.456 11.8637 14.6667 11.3333 14.6667H4.66665C4.13621 14.6667 3.62751 14.456 3.25243 14.0809C2.87736 13.7058 2.66665 13.1971 2.66665 12.6667V3.33335C2.66665 2.80292 2.87736 2.29421 3.25243 1.91914C3.62751 1.54406 4.13621 1.33335 4.66665 1.33335H7.67665C7.78665 1.33335 7.89198 1.35468 7.99998 1.36468V4.66669C7.99998 5.19712 8.2107 5.70583 8.58577 6.0809C8.96084 6.45597 9.46955 6.66669 9.99998 6.66669H13.302C13.312 6.77469 13.3333 6.88002 13.3333 6.99002V12.6667ZM11.1493 8.87402C11.271 9.00208 11.337 9.17322 11.3326 9.34985C11.3282 9.52648 11.2539 9.69415 11.126 9.81602L8.73332 12.092C8.35721 12.4622 7.85004 12.6687 7.32231 12.6666C6.79459 12.6645 6.2891 12.4539 5.91598 12.0807L4.88931 11.1647C4.75724 11.0469 4.67735 10.8815 4.66722 10.7049C4.66221 10.6174 4.67447 10.5298 4.70331 10.4471C4.73215 10.3643 4.77701 10.2881 4.83531 10.2227C4.89362 10.1573 4.96424 10.104 5.04313 10.0659C5.12203 10.0278 5.20766 10.0056 5.29513 10.0006C5.47179 9.99047 5.64524 10.0509 5.77731 10.1687L6.83398 11.1114C6.89447 11.1793 6.96822 11.2341 7.0507 11.2725C7.13317 11.3108 7.22263 11.3319 7.31355 11.3344C7.40448 11.3369 7.49495 11.3208 7.57941 11.287C7.66387 11.2532 7.74052 11.2025 7.80465 11.138L10.2046 8.85069C10.2681 8.79001 10.3429 8.74247 10.4248 8.71078C10.5067 8.6791 10.5941 8.66391 10.6818 8.66608C10.7696 8.66825 10.8561 8.68773 10.9363 8.72342C11.0165 8.7591 11.0889 8.81028 11.1493 8.87402Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2731_135766">
            <rect width={size} height={size} fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

FileCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

FileCheck.displayName = 'FileCheck';

export default FileCheck;
